<template>
    <dx-check-box :value="checkbox" text="Текущие записи" @value-changed="onValueChange" />
    <div style="height: 40%">
        <ai-grid-ro
            :meta="metaResolution"
            :args="argsGrid"
            ref="gridRoRef"
            :rowClickCallBack="rowClick"
            :show-filter-panel="false"
        />
    </div>
    <ai-tree-list-edit
        :meta="metaOkved"
        :args="argsTreelist"
        ref="treeListRef"
        :toRemoveToolbarItemsNames="[
            'choice',
            'moveSave',
            'moveTo',
            'copy',
            'edit',
            'addSibling',
            'addChild',
            'delete',
            'save',
        ]"
    />
</template>

<script setup>
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { onMounted, ref, watch } from 'vue';
import AiGridRo from '@/components/ai-grid-ro/ai-grid-ro.vue';
import { mainState } from '@/layouts/main-layout/main-layout-data';

const checkbox = ref(true);
const gridRoRef = ref();
const treeListRef = ref();

onMounted(async () => {
    await treeListRef.value.setCacheOrApiDataSource();
    treeListRef.value.treeListInstance.autoExpandAll = false;
});

watch(
    () => mainState.routePath,
    async () => {
        await treeListRef.value.setCacheOrApiDataSource();
    }
);

const rowClick = async e => {
    if (argsTreelist.select.select_args.kod_res_okved !== e.row.kod_res_okved) {
        argsTreelist.select.select_args.kod_res_okved = e.row.kod_res_okved;
        await treeListRef.value.setDataSource();
    }
};

const metaResolution = {
    keyExpr: 'kod_res_okved',
    title: 'Версия ОКВЭД',
    columns: [
        {
            name: 'res_name',
            caption: 'Редакция справочника',
            dataField: 'res_name',
            width: 310,
            index: 1,
            visible: true,
        },
        {
            name: 'res_date_from',
            caption: 'Дата начала действия',
            dataField: 'res_date_from',
            width: 172,
            index: 2,
            visible: true,
            dataType: 'date',
            format: 'dd-MM-yyyy',
        },
        {
            name: 'res_date_to',
            caption: 'Дата окончания действия',
            dataField: 'res_date_to',
            width: 184,
            index: 3,
            visible: true,
            dataType: 'date',
            format: 'dd-MM-yyyy',
        },
        {
            name: 'res_remark',
            caption: 'Примечания',
            dataField: 'res_remark',
            index: 4,
            visible: true,
        },
        {
            name: 'kod_res_okved',
            caption: 'kod_res_okved',
            dataField: 'kod_res_okved',
            width: 53,
            index: 5,
            visible: false,
        },
    ],
    api: {
        select: 'nsi./nsi/view-ks-okved-resolution/select/get',
    },
    viewId: 'view-ks-okved-resolution',
};
const metaOkved = {
    title: 'ОКВЭД',
    rights: {},
    columns: [
        {
            name: 'kod_okved',
            caption: 'kod_okved',
            dataField: 'kod_okved',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                editorText: '',
                name: '',
                id: '',
                text: '',
            },
            width: 103,
            index: 3,
            visible: false,
        },
        {
            name: 'kod_razd',
            caption: 'kod_razd',
            dataField: 'kod_razd',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                editorText: '',
                name: '',
                id: '',
                text: '',
            },
            width: 107,
            index: 4,
            visible: false,
        },
        {
            name: 'okved',
            caption: 'ОКВЭД',
            dataField: 'okved',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                editorText: '',
                name: '',
                id: '',
                text: '',
            },
            width: 505,
            index: 1,
            visible: true,
        },
        {
            name: 'name',
            caption: 'Наименование',
            dataField: 'name',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                editorText: '',
                name: '',
                id: '',
                text: '',
            },
            width: 703,
            index: 2,
            visible: true,
        },
        {
            name: 'parent_kod_okved',
            caption: 'parent_kod_okved',
            dataField: 'parent_kod_okved',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                editorText: '',
                name: '',
                id: '',
                text: '',
            },
            width: 176,
            index: 5,
            visible: false,
        },
        {
            name: 'god',
            caption: 'god',
            dataField: 'god',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                editorText: '',
                name: '',
                id: '',
                text: '',
            },
            width: 81,
            index: 6,
            visible: false,
        },
        {
            name: 'mes',
            caption: 'mes',
            dataField: 'mes',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                editorText: '',
                name: '',
                id: '',
                text: '',
            },
            width: 75,
            index: 7,
            visible: false,
        },
        {
            name: 'kod_res_okved',
            caption: 'kod_res_okved',
            dataField: 'kod_res_okved',
            allowEditing: false,
            editor: {
                type: 'default',
            },
            component: {
                editorText: '',
                name: '',
                id: '',
                text: '',
            },
            width: 250,
            index: 8,
            visible: false,
        },
    ],
    api: {
        select: 'nsi./nsi/view-ks-okved/select/get',
    },
    keyExpr: 'kod_okved',
    parentIdExpr: 'parent_kod_okved',
    viewId: 'view-ks-okved',
    toolbarItems: [
        {
            widget: 'dx-button',
            component: {
                name: 'refresh',
                hint: 'Обновить',
                emits: [{ name: 'click' }],
                htmlElement: 'ai-refresh-base',
            },
        },
    ],
};

const argsGrid = {
    select_args: {
        select_arg: checkbox.value,
    },
};

const argsTreelist = {
    select: {
        select_args: {
            kod_res_okved: 1,
        },
    },
};

const onValueChange = async e => {
    checkbox.value = e.value;
    argsGrid.select_args.select_arg = e.value;

    await gridRoRef.value.setDataSource();
};
</script>

<script>
export default {
    name: 'ks-okved-view',
};
</script>

<style scoped></style>
